// Format currency values to ILS format
export const formatCurrency = (value) => {
  if (!value) return "0 ₪";
  return `${Number(value).toLocaleString()} ₪`;
};

// Format percentage values
export const formatPercent = (value) => {
  if (!value) return "0%";
  return `${Number(value).toFixed(2)}%`;
};

// Get color scheme for track types
export const getTrackColor = (trackTypeId) => {
  const trackId = parseInt(trackTypeId);
  
  // Different color schemes for different track types
  switch(trackId) {
    case 1: // פריים
      return {
        main: '#2196f3',
        light: '#e3f2fd',
        dark: '#1565c0',
        border: '#bbdefb'
      };
    case 2: // קבועה צמודה
      return {
        main: '#4caf50',
        light: '#e8f5e9',
        dark: '#2e7d32',
        border: '#c8e6c9'
      };
    case 3: // קבועה לא צמודה
      return {
        main: '#9c27b0',
        light: '#f3e5f5',
        dark: '#7b1fa2',
        border: '#e1bee7'
      };
    case 4: // משתנה כל 5 שנים
      return {
        main: '#ff9800',
        light: '#fff3e0',
        dark: '#ef6c00',
        border: '#ffe0b2'
      };
    case 5: // משתנה כל שנה
      return {
        main: '#f44336',
        light: '#ffebee',
        dark: '#c62828',
        border: '#ffcdd2'
      };
    case 14: // משתנה כל 3 שנים לא צמודה
      return {
        main: '#009688',
        light: '#e0f2f1',
        dark: '#00695c',
        border: '#b2dfdb'
      };
    default:
      return {
        main: '#607d8b',
        light: '#eceff1',
        dark: '#455a64',
        border: '#cfd8dc'
      };
  }
}; 